// src/config.ts
export type CarbonWebConfig = {
  // Env - dev, test, prod, etc
  ddEnv: string;
  // Public RUM Application ID
  ddRumApplicationId: string;
  // Public RUM Client Token
  ddRumClientToken: string;
  // Application name - e.g. socius, felix, horizon, etc
  ddService: string;
  // 0 to 100 value for what percent of session to use screen replay. Needs ddSessionReplaySampleRate
  ddSessionReplaySampleRate: number;
  // 0 to 100 value for what percent of sessions to sample
  ddSessionSampleRate: number;
  // our DD site - usually us3.datadoghq.com
  ddSite: string;
  // The various tracing URLs allowed
  ddAllowedTracingUrls: (string | RegExp)[] | undefined;
};

// TODO - eventually utilize an apiBaseUrl that can pull these from our BE that can pull Azure configs
// ddRumAppId and ddRumClientToken are public
const MAP: Record<string, CarbonWebConfig> = {
  localhost: {
    ddEnv: 'local',
    ddRumApplicationId: '6b7e2945-4c20-4e88-b207-6651a2d82bc4',
    ddRumClientToken: 'pub4f6ef8b6307f4444e484902588f1229e',
    ddService: 'carbon-web',
    ddSessionReplaySampleRate: 100,
    ddSessionSampleRate: 100,
    ddSite: 'us3.datadoghq.com',
    ddAllowedTracingUrls: [
      /^http(s):\/\/([a-zA-Z0-9-]+\.)?wshtech\.com/,
      /^http(s):\/\/([a-zA-Z0-9-]+\.)?wsh-lighthouse-e1-prod\.com/,
      /^http(s):\/\/([a-zA-Z0-9-]+\.)?westshorehome\.com/,
      /^http(s)?:\/\/localhost(?::\d+)?(?:\/|$)/,
    ],
  },
  'dev-carbon.wsh-lighthouse-e1-prod.com': {
    ddEnv: 'dev',
    ddRumApplicationId: '6b7e2945-4c20-4e88-b207-6651a2d82bc4',
    ddRumClientToken: 'pub4f6ef8b6307f4444e484902588f1229e',
    ddService: 'carbon-web',
    ddSessionReplaySampleRate: 0,
    ddSessionSampleRate: 0,
    ddSite: 'us3.datadoghq.com',
    ddAllowedTracingUrls: [
      /^http(s):\/\/([a-zA-Z0-9-]+\.)?wshtech\.com/,
      /^http(s):\/\/([a-zA-Z0-9-]+\.)?wsh-lighthouse-e1-prod\.com/,
      /^http(s):\/\/([a-zA-Z0-9-]+\.)?westshorehome\.com/,
    ],
  },
  'test-carbon.wsh-lighthouse-e1-prod.com': {
    ddEnv: 'test',
    ddRumApplicationId: '6b7e2945-4c20-4e88-b207-6651a2d82bc4',
    ddRumClientToken: 'pub4f6ef8b6307f4444e484902588f1229e',
    ddService: 'carbon-web',
    ddSessionReplaySampleRate: 0,
    ddSessionSampleRate: 100,
    ddSite: 'us3.datadoghq.com',
    ddAllowedTracingUrls: [
      /^http(s):\/\/([a-zA-Z0-9-]+\.)?wshtech\.com/,
      /^http(s):\/\/([a-zA-Z0-9-]+\.)?wsh-lighthouse-e1-prod\.com/,
      /^http(s):\/\/([a-zA-Z0-9-]+\.)?westshorehome\.com/,
    ],
  },
  'beta-carbon.wsh-lighthouse-e1-prod.com': {
    ddEnv: 'beta',
    ddRumApplicationId: '6b7e2945-4c20-4e88-b207-6651a2d82bc4',
    ddRumClientToken: 'pub4f6ef8b6307f4444e484902588f1229e',
    ddService: 'carbon-web',
    ddSessionReplaySampleRate: 0,
    ddSessionSampleRate: 0,
    ddSite: 'us3.datadoghq.com',
    ddAllowedTracingUrls: [
      /^http(s):\/\/([a-zA-Z0-9-]+\.)?wshtech\.com/,
      /^http(s):\/\/([a-zA-Z0-9-]+\.)?wsh-lighthouse-e1-prod\.com/,
      /^http(s):\/\/([a-zA-Z0-9-]+\.)?westshorehome\.com/,
    ],
  },
};

// Default to production if no match
const DEFAULT: CarbonWebConfig = {
  ddEnv: 'prod',
  ddRumApplicationId: '6b7e2945-4c20-4e88-b207-6651a2d82bc4',
  ddRumClientToken: 'pub4f6ef8b6307f4444e484902588f1229e',
  ddService: 'carbon-web',
  ddSessionReplaySampleRate: 0,
  ddSessionSampleRate: 100,
  ddSite: 'us3.datadoghq.com',
  ddAllowedTracingUrls: [
    /^http(s):\/\/([a-zA-Z0-9-]+\.)?wshtech\.com/,
    /^http(s):\/\/([a-zA-Z0-9-]+\.)?wsh-lighthouse-e1-prod\.com/,
    /^http(s):\/\/([a-zA-Z0-9-]+\.)?westshorehome\.com/,
  ],
};

export const CONFIG: CarbonWebConfig = MAP[window.location.hostname] ?? DEFAULT;
